export const jobTypes = [
    { label: "Full time", value: "full-time" },
    { label: "Part time", value: "part-time" },
    { label: "Freelance/project", value: "freelance-project" },
    { label: "work from home", value: "work-from-home" },
    { label: "Shift based", value: "shift-based" },
  ];
  
